const GetMaintenances = `
  query Query($count: Int, $cursor: String) {
    systemMaintenances(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          description
          startTime
          endTime
          template {
            id
            name
            description
          }
        }
      }
    }
  }
`

const AddMaintenance = `
  mutation($id: String!, $template: String!, $startTime: AWSDateTime!, $endTime: AWSDateTime!) {
    addSystemMaintenance(input: {
      id:        $id
      template:  $template
      startTime: $startTime
      endTime:   $endTime
    }) {
      ...on UpdateSuccess {
        id
      }
      ...on UpdateFailure {
        errorMessage
      }
    }
  }
`

const GetMaintenanceTemplates = `
  query Query($count: Int, $cursor: String) {
    systemMaintenanceTemplates(first: $count, after: $cursor) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          description
        }
      }
      
    }
  }
`

const GetMaintenanceTemplate = `
  query Query($id: String!) {
    systemMaintenanceTemplate(id: $id) {
      id
      name
      description
      integrations {
        sender {
          id
          name
          description
        }
        receiver {
          id
          name
          description
        }
        dataType {
          id
          name
          description
        }
      }
    }  
  }
`

const AddMaintenanceTemplate = (maintenanceTemplate) => {
  const integrationMap = maintenanceTemplate.integrations.map(({ sender, receiver, dataType }) => {  
    return `{
      sender:   "${sender}"
      receiver: "${receiver}"
      dataType: "${dataType}"
    }`
  }).join('')

  return `
    mutation {
      addSystemMaintenanceTemplate(input: {
        id:          "${maintenanceTemplate.id}"
        name:        "${maintenanceTemplate.name}"
        description: "${maintenanceTemplate.description}"
        integrations: [
          ${integrationMap}
        ]
      }) {
        ...on UpdateSuccess {
          id
        }
        ...on UpdateFailure {
          errorMessage
        }
      }  
    }  
  `
}

const DeleleteMaintenance = `
  mutation($id: String!) {
    deleteSystemMaintenance(id: $id) {
      ...on UpdateSuccess {
        id
      }
      ...on UpdateFailure {
        errorMessage
      }
    }
  }
`

const DeleleteMaintenanceTemplate = `
  mutation($id: String!) {
    deleteSystemMaintenanceTemplate(id: $id) {
      ...on UpdateSuccess {
        id
      }
      ...on UpdateFailure {
        errorMessage
      }
    }
  }
`

module.exports = {
  AddMaintenance,
  GetMaintenances,
  DeleleteMaintenance,
  GetMaintenanceTemplate,
  GetMaintenanceTemplates,
  AddMaintenanceTemplate,
  DeleleteMaintenanceTemplate,
}
